import top from '@pages/Top.vue'

export default [
  {
    path: '/'
    name: 'top'
    component: top
  },
]



// WEBPACK FOOTER //
// ./node_modules/coffeelint-loader??ref--3-0!./src/routes.coffee